import 'css-chunksrc/client/scenes/calendar/week/styles.scss';export default {
  "week": "_week_1fkqe_1",
  "grid": "_grid_1fkqe_6",
  "day": "_day_1fkqe_12",
  "dayIndex": "_dayIndex_1fkqe_27",
  "event": "_event_1fkqe_35",
  "wrapper": "_wrapper_1fkqe_42",
  "more": "_more_1fkqe_47",
  "iconBox": "_iconBox_1fkqe_59",
  "icon": "_icon_1fkqe_59",
  "weekEndDay": "_weekEndDay_1fkqe_85",
  "today": "_today_1fkqe_88",
  "empty": "_empty_1fkqe_95",
  "selectedDate": "_selectedDate_1fkqe_117"
};